"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpload = void 0;

var _react = require("react");

var _useUpload = require("./library/use-upload");

const useUpload = beforeRequest => {
  const [state, setState] = (0, _react.useState)({
    loading: false,
    done: false
  });
  const upload = (0, _useUpload.useUploadCreator)({
    beforeRequest,
    setState,
    updateState: setState
  });
  return [upload, state];
};

exports.useUpload = useUpload;